import { style, animate, transition, trigger, state, AnimationTriggerMetadata } from '@angular/animations';


export const scrubAnimation = trigger('scrubAnimation',
  [
    state('endState', style({ top: '{{topEnd}}' }),
      {
        params: {
          topEnd: '*'
        }
      }),
    transition('* => endState', animate('{{time}}'))
  ]
);

export const EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';

export const expansionAnimations: {
  readonly indicatorRotate: AnimationTriggerMetadata;
  readonly bodyExpansion: AnimationTriggerMetadata;
} = {
  /** Animation that rotates the indicator arrow. */
  indicatorRotate: trigger('indicatorRotate', [
    state('collapsed, void', style({ transform: 'rotate(0deg)' })),
    state('expanded', style({ transform: 'rotate(180deg)' })),
    transition('expanded <=> collapsed, void => collapsed',
      animate(EXPANSION_PANEL_ANIMATION_TIMING)),
  ]),
  /** Animation that expands and collapses the panel content. */
  bodyExpansion: trigger('bodyExpansion', [
    transition(':enter', [
      animate(EXPANSION_PANEL_ANIMATION_TIMING, style({ height: '*' })),
    ]),
    transition(':leave', [
      animate(EXPANSION_PANEL_ANIMATION_TIMING, style({ height: '0px' })
      )
    ])
  ])
};

export const fabAnimations: {
  readonly fab: AnimationTriggerMetadata;
} = {
  /** Animation that translate FAB. */
  fab: trigger('fab', [
    state('enter, void', style({
       transform: 'translateY(-104px)'
       })),
    state('leave', style({
       transform: 'translateY(104px)'
       })),
    transition('enter => leave',
      animate(EXPANSION_PANEL_ANIMATION_TIMING)),
    transition('* => enter',
      animate(EXPANSION_PANEL_ANIMATION_TIMING)),
    ])
  };
